import type { Price} from "./price";
import { zeroPrice } from "./price";

const findMaxPrice = <T>(
    items: T[],
    iteratee: (item: T) => Price | undefined
): Price =>
    items.reduce((agg, item) => {
        const currentPrice = iteratee(item);
        if (!currentPrice) return agg;
        const _max = (price: Price) =>
            price?.amountIncludingVat || Number.MIN_SAFE_INTEGER;

        const aggregatedMinPrice = _max(agg);
        const currentMinPrice = _max(currentPrice);

        if (aggregatedMinPrice < currentMinPrice) agg = currentPrice;
        return agg;
    }, zeroPrice);

export { findMaxPrice };
